import { connect } from 'react-redux';
import ExcelUploadModal from '../../../components/products/ExcelUploadModal';
import { searchReportOptions } from 'core/selectors';
import { uploadExcel } from 'core/slices/excel';

export default connect(
  (state) => ({
    reportOptions: searchReportOptions(state),
  }),
  {
    onUpload: uploadExcel,
  },
)(ExcelUploadModal);
